import type { SVGProps } from 'react';

const AngleRightIcon = ({
  color = 'var(--secondaryText)',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={8}
    height={14}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    color={color}
  >
    <path
      d="m5.172 7-4.95 4.95 1.414 1.414L8 7 1.636.636.222 2.05 5.172 7Z"
      fill="currentColor"
    />
  </svg>
);

export default AngleRightIcon;
